var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLytics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7143 6.85714C13.7143 3.07005 10.6442 0 6.85714 0C3.07005 0 0 3.07005 0 6.85714V86.1606V121.143C0 124.93 3.07005 128 6.85714 128H121.143C124.93 128 128 124.93 128 121.143C128 117.356 124.93 114.286 121.143 114.286H13.7143V88.8713L33.8529 67.3653C36.5136 68.8789 39.5917 69.7434 42.8717 69.7434C47.0191 69.7434 50.8438 68.3611 53.91 66.0321L66.9146 78.1614C66.3086 79.9809 65.9805 81.9274 65.9805 83.9506C65.9805 94.062 74.1774 102.259 84.2889 102.259C94.4004 102.259 102.597 94.062 102.597 83.9506C102.597 79.2349 100.815 74.9356 97.8862 71.69L97.9079 71.6313L108.501 42.5346C117.825 41.7057 125.134 33.8739 125.134 24.3348C125.134 14.2433 116.954 6.0625 106.862 6.0625C96.7706 6.0625 88.5898 14.2433 88.5898 24.3348C88.5898 30.0685 91.2307 35.1853 95.3624 38.5354L85.4796 65.6802C85.0859 65.6549 84.6889 65.6421 84.2889 65.6421C81.2335 65.6421 78.3528 66.3906 75.8203 67.7142L61.7139 54.5572C61.4771 54.3364 61.2289 54.1355 60.9713 53.9546C61.0811 53.1445 61.1378 52.3175 61.1378 51.4772C61.1378 41.3891 52.9598 33.211 42.8717 33.211C32.7835 33.211 24.6055 41.3891 24.6055 51.4772C24.6055 53.2039 24.8451 54.8746 25.2928 56.458C25.2004 56.5463 25.11 56.6377 25.0216 56.7321L13.7143 68.8071V6.85714Z",
    fill: "#D99A26"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLytics);
export default __webpack_public_path__ + "static/media/lytics.d41493ba40c2d77ffc0ce46eb0a38009.svg";
export { ForwardRef as ReactComponent };